import $ from 'jquery';
import * as checkoutTrackingHelper from '../../../home24-shared/tracking/checkout/helper';
import CartEvents from '../../tracking/cart/CartEvents';
import Address from '../../tracking/checkout/Address';
import Index from '../../tracking/checkout/Index';
import LoginEvents from '../../tracking/checkout/LoginEvents';
import Payment from '../../tracking/checkout/Payment';
import { register } from '../../core/bootstrapper';

register(null, function () {

    var login = new LoginEvents({
        $el: $('body')
    });

    $(document).ready(function () {
        login.executeCookieCallbacks();
    });
});

register('checkout-index', function () {

    var $page = $('.checkout-index-page');

    const cartEvents = new CartEvents({
        el: $page
    });

    const addressEvents = new Address({
        el: $('.checkout-address-page')
    });

    new Index({
        el: $page
    });

    $(document).ready(function () {

        checkoutTrackingHelper.addressSendTrackingData();
        checkoutTrackingHelper.paymentSendTrackingData();
        checkoutTrackingHelper.indexSendTrackingData();

        cartEvents.executeCookieCallbacks();
        addressEvents.executeCookieCallbacks();
    });

});

register('checkout-payment', function () {

    new Payment({
        el: $('.checkout-payment-page')
    });

    const addressEvents = new Address({
        el: $('.checkout-address-page')
    });

    $(document).ready(function () {

        checkoutTrackingHelper.paymentSendTrackingData();

        addressEvents.executeCookieCallbacks();
    });

});

register('checkout-address', function () {

    /*
     Process all tracking for checkout address page
     */
    const addressEvents = new Address({
        el: $('.checkout-address-page')
    });

    $(document).ready(function () {

        checkoutTrackingHelper.addressSendTrackingData();

        addressEvents.executeCookieCallbacks();
    });

});

register('success', function () {

    $(document).ready(function () {
        checkoutTrackingHelper.successSendTrackingData();
    });
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/checkout/trackingBootstrap.js
 **/